const getters = {
  getRecommendedProducts(state) {
    if (state.recommendedProducts && state.recommendedProducts.length > 0) {
      return state.recommendedProducts;
    }
    if (window.MDC_RECOMMENDATION_OBJECT && window.MDC_RECOMMENDATION_OBJECT.block) {
      return window.MDC_RECOMMENDATION_OBJECT.block;
    }
    return [];
  },
  getRecommendedProductsForCart(state) {
    if (state.recommendedCartProducts && state.recommendedCartProducts.length > 0) {
      return state.recommendedCartProducts;
    }
    if (window.MDC_RECOMMENDATION_OBJECT && window.MDC_RECOMMENDATION_OBJECT.cart) {
      return window.MDC_RECOMMENDATION_OBJECT.cart;
    }
    return [];
  },
  getPageViewCount(state) {
    return state.pageViewCount
  }
}

export default getters
